<template>
  <el-row v-loading="loading">
    <el-row class="padding_5px_top padding_10px_bottom">
      <el-col
        :span="12"
        class="left_text_align"
        style="margin-left: 10px;"
      >
        <el-col
          :span="4"
          class="companyEvaluation_label"
        >
          基金公司：
        </el-col>
        <el-col :span="11">
          <el-select
            class="companyEvaluation_Company"
            v-model="curCompanyName"
            filterable
            clearable
            placeholder="请选择或输入公司首拼、关键字"
            :filter-method="fiterCompany"
          >
            <el-option
              v-for="item in filteredCompanyList"
              :key="item.companyName"
              :label="item.companyName"
              :value="item.companyName"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col
          :span="4"
          class="right_text_align"
        >
          <el-button
            @click="getCompanyEvaluationByName()"
            type="primary"
          >查询</el-button>
        </el-col>
      </el-col>
      <el-col
        :span="9"
        class="right_text_align"
      >
        <el-popover
          placement="bottom"
          width="300"
          v-model="downloadAllVisible"
        >
          <el-row
            v-loading="dialogLoading"
            style="text-align: center; margin: 0"
          >
            <p>请确认是否发送全部报告到FTP</p>
            <el-button
              round
              @click="downloadAllVisible = false"
            >取 消</el-button>
            <el-button
              type="primary"
              round
              @click="handleDownloadAll"
            >确 定</el-button>
          </el-row>
          <el-button
            slot="reference"
            icon="el-icon-download"
          >发送全部报告到FTP</el-button>
        </el-popover>
      </el-col>
    </el-row>
    <el-table
      :data="tableData"
      @sort-change="sortChange"
      :default-sort="{ prop: 'assessmentResult', order: 'descending' }"
      style="width: 100%"
    >
      <el-table-column
        type="index"
        label="序号"
        width="50"
      ></el-table-column>
      <el-table-column
        prop="companyName"
        label="基金管理公司名称"
        min-width="10%"
        sortable="custom"
      ></el-table-column>
      <el-table-column
        prop="inceptionDate"
        label="成立时间"
        min-width="10%"
        sortable="custom"
      >
        <template slot-scope="scope">
          {{ scope.row.inceptionDate | replaceTime }}
        </template></el-table-column>
      <el-table-column
        prop="assessmentResult"
        label="审慎调查结论"
        min-width="9%"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="effectiveDate"
        label="评价时间"
        min-width="8%"
      >
        <template slot-scope="scope">
          {{ scope.row.effectiveDate | replaceTime }}
        </template>
      </el-table-column>
      <el-table-column
        prop="targetFolder"
        label="审慎调查报告"
        min-width="9%"
      >
        <template slot-scope="scope">
          <el-button
            @click="
                            downloadFile({
                                url: scope.row.targetFolder,
                                fileName: scope.row.companyName
                            })
                        "
            size="small"
            :disabled="disableExport"
          >下载</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-col class="left_text_align padding_25px_top">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :page-sizes="[10, 20, 50, 100,200]"
        :page-size="pagination.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="(pagination && pagination.count) || 0"
        v-if="pagination.count > 10 ? true : false"
      >
      </el-pagination>
    </el-col>
  </el-row>
</template>
<script>
import { Message } from "element-ui";
import {
    getCompanyEvaluation,
    getCompanyEvaluationByName,
    sendAllCompanyReportByFTP
} from "../../api/suitability";
import { fiterCompany } from "./mixin/fiterCompany";

const componentsCommon=require("cb-components-common").default;
const checkResponseStatus=componentsCommon.common.checkResponseStatus;
const getDisableExport=componentsCommon.common.getDisableExport;
const getSuitabilityMemberBaseTrial = componentsCommon.common.getSuitabilityMemberBaseTrial;
const fetchFile=componentsCommon.downloadUtils.fetchFile;
const downloadFtpFile=componentsCommon.apiCommon.downloadFtpFile;

export default {
    mixins: [fiterCompany],
    data() {
        return {
            dialogLoading: false,
            downloadAllVisible: false,
            loading: false,
            curCompanyName: "",
            pagination: {
                skip: 0,
                limit: 10,
                count: 0
            },
            params: {
                companyName: "",
              sort: "assessmentResult",
                order: "desc",
                limit: 10,
                skip: 0,
                page: 1
            },
            tableData: [],
            disableExport:true
        };
    },
    filters: {
        replaceTime(value) {
            if (value != undefined && value != null && value != "") {
                return value.replace("00:00:00.0", "");
            } else {
                return "--";
            }
        }
    },
    mounted() {
      this.disableExport = getDisableExport()||getSuitabilityMemberBaseTrial();
    },
    methods: {
        getCompanyEvaluationByName() {
            let self = this;
            self.loading = true;
            if (!self.curCompanyName) {
                self.company(self.params);
            } else {
                getCompanyEvaluationByName(self.curCompanyName)
                    .then(response => {
                        let jsonData = response.data;
                        if (jsonData == undefined) {
                            Message({
                                message: "数据异常，请尝试刷新再试！",
                                type: "error",
                                duration: 2 * 1000
                            });
                            Message.close = function() {};
                        } else {
                            if (checkResponseStatus(jsonData, self)) {
                                self.pagination = jsonData.pagination;
                                self.tableData =
                                    jsonData.data.companyEvaluation;
                            }
                        }
                    })
                    .catch(err => {
                        self.loading = false;
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    })
                    .finally(r => {
                        self.loading = false;
                    });
            }
        },
        company(params) {
            let self = this;
            self.loading = true;
            getCompanyEvaluation(params)
                .then(response => {
                    let jsonData = response.data;
                    if (jsonData == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(jsonData, self)) {
                            self.pagination = jsonData.pagination;
                            self.tableData = jsonData.data.companyEvaluation;
                        }
                    }
                })
                .catch(err => {
                    self.loading = false;
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.loading = false;
                });
        },
        handleSizeChange(val) {
            const self = this;
            self.params.limit = val;
            self.company(self.params);
        },
        handleCurrentChange(val) {
            const self = this;
            self.params.page = val;
            self.params.skip = (val - 1) * self.params.limit;
            self.company(self.params);
        },
        sortChange(column, prop, order) {
            let self = this;
            if (column.order != undefined) {
                self.params.order = column.order
                    .replace("ascending", "asc")
                    .replace("descending", "desc");
                self.params.sort = column.prop;
                self.company(self.params);
            }
            console.log(column + "-" + column.prop + "-" + column.order);
        },
        loadingData() {
            let self = this;
            self.handleCompany();
            self.company(self.params);
        },
        downloadFile(data) {
            let fileName = data.fileName + ".pdf";
            let fileType = "application/pdf;charset=utf-8";
            downloadFtpFile(data)
                .then(response => {
                    let data = response.data;
                    if (response.status == 200) {
                        fetchFile(data, fileType, fileName);
                    }
                    self.loading = false;
                })
                .catch(err => {
                    self.loading = false;
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.loading = false;
                });
        },
        handleDownloadAll() {
            const self = this;
            self.dialogLoading = true;
            self.downloadAllVisible = false;
            sendAllCompanyReportByFTP()
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            Message({
                                message: "定时任务已启动，请半小时后查看FTP",
                                type: "success",
                                duration: 5 * 1000
                            });
                            Message.close = function() {
                                //self.loadInfoData();
                            };
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.dialogLoading = false;
                });
        }
    }
};
</script>
<style lang="scss">
@import "../../public/sass/components/companyEvaluation";
</style>